import React, {useRef} from "react";
import IconChevronRipple from "../../shared/icon-chevron-ripple";
import StaticTestimonial from "../../shared/static-testimonial";
import BgGradientBlue from "../../shared/bg-gradient-blue";
import styles from "./styles.css";
import Image1 from "../../shared/images/unknown-buyers.png";
import Image2 from "../../shared/images/sharing-personal.png";
import Image3 from "../../shared/images/quoting-fake-prices.png";
import Image4 from "../../shared/images/car-ownership.png";
import Image5 from "../../shared/images/getting-payment.png";
import Image6 from "../../shared/images/taking-multiple-call.png";
import Image7 from "../../shared/images/finding-time.png";
import testimonialImage from "../../shared/images/price-testimonial.png";
import scrollToView from "../../../utils/helpers/scroll-to-view";
import LegacyForm from "../legacy-form";
import SellCarImage from "../../shared/images/car-illustration.png";

const ClassifiedCars24Info = () => {
    const adRef = useRef();

    const onClickHandler = () => {
        scrollToView(adRef.current);
    };

    return (
        <React.Fragment>
            <BgGradientBlue>
                <div styleName={"styles.headingWrap"}>
                    <h1>Selling your used car via online
                        classifieds - <span> not a great idea!</span></h1>
                    <p>
                    There are many innocent sellers who become victims of fake online
                    offers everyday, don't be one of them
                    </p>
                    <IconChevronRipple onClick={onClickHandler} />
                </div>
            </BgGradientBlue>
            <section ref={adRef} styleName={"styles.whyCARS24 "}>
                <div className="container">
                    <div className={"row"}>
                        <div className={"col-11 mx-auto"}>
                            <h2>Perils of selling a car through a
                                <br/> classified advertisement
                            </h2>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Meeting unknown buyers could be dangerous</h3>
                                    <p>It doesn't take much to create a fake online profile on
                                the various social channels we have today.
                                There are high possibilities that you come
                                across someone with sinister thoughts.
                                The consequences of which might leave you repenting
                                for the rest of your life.
                                    </p>
                                </div>
                                <div className="col-6" >
                                    <img src={Image1} className="img-fluid" />
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" >
                                    <img src={Image2} className="img-fluid" />
                                </div>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Sharing personal details online is not safe</h3>
                                    <p>Keeping your personal data secured online takes a
                                tad bit of time and effort. The more information
                                you have online, greater the chances of them reaching
                                the wrong hands.
                                    </p>
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Quoting fake prices by random buyers
                                is very common online</h3>
                                    <p>You often find quotes on the higher end listed by
                                random buyers on several online platforms. Getting
                                lured by them, when you want to sell something fast,
                                is quiet natural. However, the internet is an open
                                platform where anyone and everyone can just quote a price.
                                    </p>
                                </div>
                                <div className="col-6" >
                                    <img src={Image3} className="img-fluid" />
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" >
                                    <img src={Image4} className="img-fluid" />
                                </div>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Car ownership not transferred on time
                                is a serious issue</h3>
                                    <p>This is the problem most car sellers face,
                                which involves a tedious paperwork. Therefore,
                                to avoid the time-taking and mind-baffling documentation
                                process, it's always wise to seek help from professionals.
                                Cars24 can get this done for you while you can chill & relax.
                                    </p>
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Getting 100% payment could be a nightmare</h3>
                                    <p>Now, this is the biggest problem car seller's encounter.
                                If you ask unknown or local dealers to help you sell your
                                car, get ready for uncountable numbers of follow-ups for
                                your own money. Cars24 guarantees instant cash in your account.
                                    </p>
                                </div>
                                <div className="col-6" >
                                    <img src={Image5} className="img-fluid" />
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" >
                                    <img src={Image6} className="img-fluid" />
                                </div>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Taking multiple calls from non-serious buyers is a pain</h3>
                                    <p>There are several online platforms where you can post
                                your car selling requirement. However, the chance of
                                meeting a genuine buyer on most of these platforms is
                                extremely low. Most of the people who dial your number
                                are not completely interested to buy.
                                    </p>
                                </div>
                            </div>

                            <div className="row" styleName={"styles.innerDiv"}>
                                <div className="col-6" styleName={"styles.paddingRight"}>
                                    <h3>Finding time for multiple test-drives is a hassle</h3>
                                    <p>Your time is precious. Anyone who comes to buy your car
                                will go for multiple test drives. Now, who likes to make
                                time from their busy schedule to take people for test
                                drives? A wiser move would be to entrust Cars24
                                for the same work.
                                    </p>
                                </div>
                                <div className="col-6" >
                                    <img src={Image7} className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="container" styleName={"styles.bottomTestimonial"}>
                <StaticTestimonial
                    headingText="See what our customers are saying"
                    imageSrc={testimonialImage}
                    text="Honesty, Integrity, Respect, Exceptional customer service...are
                    the words that come to mind and best describe our recent experience
                    with Cars24. We thank you for ensuring that everything was right with
                    the paperwork and the car was sold at ease."
                    sellerName="Pradeep Pattanath sold his Hyundai i20"
                />
            </section>
            <section styleName={"styles.sellCarWrap"}>
                <div className="container">
                    <img src={SellCarImage} />
                    <h2>Sell your car with Cars24</h2>
                    <p>Enter your car details and get the best price</p>
                    <LegacyForm leadSource={"classified_vs_cars24"} />
                </div>
            </section>
        </React.Fragment>
    );
};

export default ClassifiedCars24Info;
